// extracted by mini-css-extract-plugin
export default {"second":"certificates_second__hE2oV","card":"certificates_card__M0atb","cardBody":"certificates_cardBody__kOOne"};